import config from "./config.base";

config.server = "https://server.recipestoshare.org";

export default config;